import l from "styled-components";
import { Base as n, Input as s } from "./atoms-v2777.js";
import { Icon as a } from "./atoms-v217.js";
const t = l.label`
  ${n}
  --checkbox-size: 15px;
  --checkbox-cell: 1/1;
  --checkbox-transform: translateY(1px);

  ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.body.compact-productive")) == null ? void 0 : o.toJS();
}}

  align-items: ${({ $isSkeleton: i }) => i ? "center" : "start"};
  color: ${({ $colorTheme: i = "light", $isDisabled: o, theme: r }) => o ? r == null ? void 0 : r.get(`tokens.text.${i}.disabled`) : r == null ? void 0 : r.get(`tokens.text.${i}.primary`)};
  column-gap: 13px;
  cursor: ${({ $isDisabled: i, $isReadonly: o, $isSkeleton: r }) => i || o || r ? "default" : "pointer"};
  display: grid;
  grid-template-columns: [checkbox-cell] 1em [label-cell] auto;
  min-width: ${({ $isSkeleton: i }) => i ? "100px" : "auto"};
`, x = l.input`
  ${s}

  background-color: ${({ $colorTheme: i = "light", theme: o }) => o == null ? void 0 : o.get(`tokens.surface.${i}.background`)};
  border-radius: 2px;
  box-shadow: inset 0 0 0 1.5px
    ${({ $colorTheme: i = "light", disabled: o, readOnly: r, theme: c }) => o || r ? c == null ? void 0 : c.get(`ui.icon.${i}.disabled`) : c == null ? void 0 : c.get(`ui.icon.${i}.default`)};
  color: ${({ $colorTheme: i = "light", $isErrored: o, theme: r }) => o ? r == null ? void 0 : r.get(`ui.icon.${i}.error`) : "currentcolor"};
  display: grid;
  font: inherit;
  grid-column: var(--checkbox-cell);
  grid-row: var(--checkbox-cell);
  height: var(--checkbox-size);
  place-content: center;
  position: relative;
  transform: var(--checkbox-transform);
  width: var(--checkbox-size);

  &::before {
    box-shadow: inset var(--checkbox-size) var(--checkbox-size)
      ${({ $colorTheme: i = "light", disabled: o, readOnly: r, theme: c }) => o || r ? c == null ? void 0 : c.get(`ui.icon.${i}.disabled`) : c == null ? void 0 : c.get(`ui.icon.${i}.default`)};
    clip-path: path(
      'm13.75,0H1.25c-.33,0-.65.13-.88.37-.23.23-.37.55-.37.88v12.5c0,.33.13.65.37.88.23.23.55.37.88.37h12.5c.33,0,.65-.13.88-.37.23-.23.37-.55.37-.88V1.25c0-.33-.13-.65-.37-.88-.23-.23-.55-.37-.88-.37Zm-7.5,10.94l-3.12-3.1.99-.96,2.13,2.09,4.63-4.59.99.99-5.63,5.58Z'
    );
    content: '';
    height: var(--checkbox-size);
    transform: scale(0);
    width: var(--checkbox-size);
  }

  &:checked::before {
    transform: scale(1);
  }

  &::after {
    content: '';
    inset: 0;
    outline: 2px solid currentcolor;
    outline-offset: 1.5px;
    position: absolute;
    visibility: hidden;
  }

  &:focus-visible::after {
    visibility: visible;
  }
`, p = l.span`
  background-color: ${({ $colorTheme: i = "light", theme: o }) => o == null ? void 0 : o.get(`ui.checkbox.${i}.bkgHover`)};
  border-radius: 50%;
  box-shadow: 0 0 0 8px
    ${({ $colorTheme: i = "light", theme: o }) => o == null ? void 0 : o.get(`ui.checkbox.${i}.bkgHover`)};
  grid-column: var(--checkbox-cell);
  grid-row: var(--checkbox-cell);
  height: var(--checkbox-size);
  transform: var(--checkbox-transform);
  visibility: hidden;
  width: var(--checkbox-size);
  z-index: -1;

  ${t}:hover & {
    visibility: visible;
  }
`, k = l.div`
  ${({ theme: i }) => {
  var o;
  return (o = i == null ? void 0 : i.get("tokens.helper.productive")) == null ? void 0 : o.toJS();
}}

  align-items: center;
  color: ${({ $colorTheme: i = "light", theme: o }) => o == null ? void 0 : o.get(`tokens.text.${i}.error`)};
  display: flex;
  gap: 10px;
`, u = l(a)`
  color: ${({ $colorTheme: i = "light", theme: o }) => o == null ? void 0 : o.get(`tokens.icon.${i}.error`)};
`;
export {
  x as Checkbox,
  k as ErrorContainer,
  u as ErrorIcon,
  p as Hover,
  t as Label
};
